export default __webpack_public_path__ + "assets/images/095743a58305a2c463d8d8ab83d6afb3.svg";